import { Currency, amountToCents } from "currency";
import { Text } from "react-native-paper";

import DiscountablePriceText from "./DiscountablePriceText";

type Props = {
  amount: string;
  amountNotDiscounted: string;
  currency: Currency;
};

const PLACEHOLDER_AMOUNT = 1500;
const PLACEHOLDER_DISCOUNT_AMOUNT = 1700;

export default function DiscountablePriceInfo({
  amount,
  amountNotDiscounted,
  currency,
}: Props) {
  function toCents(amount: string) {
    return Number(amountToCents({ amount: Number(amount), currency }));
  }

  return (
    <Text>
      {'Opcional. Esto muestra un "descuento" '}
      <DiscountablePriceText
        price={toCents(amount) || PLACEHOLDER_AMOUNT}
        priceNotDiscounted={
          toCents(amountNotDiscounted) || PLACEHOLDER_DISCOUNT_AMOUNT
        }
        currency={currency}
      />
    </Text>
  );
}
